import React, { Fragment, useState } from 'react'
import { isMobile } from 'react-device-detect'
import Tweet from './Tweet'

// eslint-disable-next-line no-unused-vars
const Timeline = (tweets, props) => {
  const [isTweet, setIsTweet] = useState({})
  const [hideTweet, setHideTweet] = useState(true)
  // const [hideTweetClick, setHideTweetClick] = useState({})
  const [tweetClose, setTweetClose] = useState(false)
  const showTweet = (val) => {
    // setTimeout(function () {
    setIsTweet(val)
    setHideTweet(!val)
    // setHideTweetClick(clickBool)
    // }, 200)
  }

  const mouseIn = (el) => {
    if (!isMobile) {
      showTweet(el)
    }
  }

  const mouseOut = () => {
    if (!isMobile) {
      setHideTweet(true)
    }
  }

  // const showTweetMobile = (val) => {
  //   setTimeout(function () {
  //     setIsTweet(val)
  //     setHideTweet(!val)
  //     // setHideTweetClick(clickBool)
  //   }, 200)
  // }

  const rawbody = tweets.tweets
  const userbody = Object.keys(rawbody).map(function (k) {
    // eslint-disable-next-line radix
    const num = parseInt(k)
    return {
      likes: rawbody[k].likes,
      photo_url: rawbody[k].photo_url,
      quote_url: rawbody[k].quote_url,
      retweets: rawbody[k].retweets,
      body: rawbody[k].text,
      timestamp: rawbody[k].timestamp,
      tweet_url: rawbody[k].tweet_url,
      urls: rawbody[k].urls,
      year: num,
    }
  })

  const yearArray = [2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020]
  yearArray.forEach((year) => {
    const check = userbody.some((tweet) => tweet.year === year)
    if (check === false) {
      const yearless = {
        // eslint-disable-next-line object-shorthand
        year: year,
      }
      userbody.push(yearless)
    }
  })

  userbody.sort(function (a, b) {
    return b.year - a.year
  })

  console.log(userbody)

  const last = userbody[0]
  const first = userbody[userbody.length - 1]

  const checkTweetsEven = userbody.map((el, index) => {
    // if tweets are even year, don't include 2006 and don't have a body
    if (el.year % 2 === 0 && !el.body) {
      return <p className="user-tweet inactive" key={index}></p>
    }
    // if tweets are even year, don't include 2006___
    if (el.year % 2 === 0 && el.year !== first.year) {
      if (isMobile) {
        console.log(`mobile`)
        return (
          <Fragment key={index}>
            <div
              href={el.tweet_url}
              target="_blank"
              rel="noreferrer"
              className="user-tweet active"
              onClick={() => showTweet(el, true)}
              onMouseOver={() => mouseIn(el)}
              onMouseOut={() => mouseOut()}
            >
              <div className="tweet-year">{el.year}</div>
            </div>
          </Fragment>
        )
      }
      return (
        <Fragment key={index}>
          <a
            href={el.tweet_url}
            target="_blank"
            rel="noreferrer"
            className="user-tweet active"
            onClick={() => showTweet(el, true)}
            onMouseOver={() => mouseIn(el)}
            onMouseOut={() => mouseOut()}
          >
            <div className="tweet-year">{el.year}</div>
          </a>
        </Fragment>
      )
    }

    return null
  })

  const checkTweetsOdd = userbody.map((el, index) => {
    if (el.year % 2 !== 0 && el.year !== first.year && !el.body) {
      return <p className="user-tweet inactive" key={index}></p>
    }
    if (el.year % 2 !== 0 && el.year !== last.year) {
      if (isMobile) {
        return (
          <Fragment key={index}>
            <div href={el.tweet_url} target="_blank" rel="noreferrer" className="user-tweet active" onClick={() => showTweet(el, true)}>
              <div className="tweet-year">{el.year}</div>
            </div>
          </Fragment>
        )
      }
      return (
        <Fragment key={index}>
          <a
            href={el.tweet_url}
            target="_blank"
            rel="noreferrer"
            className="user-tweet active"
            onClick={() => showTweet(el, true)}
            onMouseOver={() => mouseIn(el)}
            onMouseOut={() => mouseOut()}
          >
            <div className="tweet-year">{el.year}</div>
          </a>
        </Fragment>
      )
    }

    return null
  })

  return (
    <div className="timeline">
      <h5 className="year first-year">{first.year}</h5>
      <div className="body">
        <div className="row row-even">{checkTweetsEven}</div>
        <div className="row row-odd">{checkTweetsOdd}</div>
      </div>
      <h5 className="year last-year">{last.year}</h5>
      {/* {hideTweet ? null : <div className="tweet-close" tweet={isTweet} tweetClose={tweetClose} setTweetClose={setTweetClose} />} */}
      {hideTweet ? null : (
        <div className="tweet-close" onClick={() => setHideTweet(true)}>
          <Tweet tweet={isTweet} tweetClose={tweetClose} setTweetClose={setTweetClose} />
        </div>
      )}
    </div>
  )
}

export default Timeline
